// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"9df0a65e","391":"1bfd9b48","551":"893fe1f7"}[chunkId] + ".chunk.css";
};